// extracted by mini-css-extract-plugin
module.exports = {"root":"ApplicazioniSection_root__viUwV","slider":"ApplicazioniSection_slider__G3aIX","rotation":"ApplicazioniSection_rotation__hHWWY"};